const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    // this.event = new Vue()

    Vue.component('ratingStars', {
      functional: true,
      props: {
        value: {
          type: [Number, String],
          required: true
        }
      },
      render: function (createElement, context) {
        // MEMO 星星計算
        // 4.2 = 4
        // 4.25 = 5
        // 4.7 = 4.5
        // 4.75 = 5
        let starsTemplate = []
        const stars = Math.floor(Number(context.props.value))
        const greyStars = 5 - Math.ceil(Number(context.props.value))
        const isHalf = Number(context.props.value) % 1 > 0
        console.debug('stars', context.props.value, '=', stars, 'and a half', isHalf, 'grey', greyStars)

        // 黃色星星
        for (let star = 0; star < stars; star++) {
          starsTemplate.push(createElement(
            'i',
            {
              class: {
                'owl-rank-star': true,
                'text-orange': true
              }
            }
          ))
        }

        // 半顆星
        if (isHalf) {
          starsTemplate.push(createElement(
            'i',
            {
              class: {
                'owl-rank-star-half': true,
                'text-orange': true
              }
            }
          ))
        }
        // 補灰色星星
        if (greyStars > 0) {
          for (let star = 0; star < greyStars; star++) {
            starsTemplate.push(createElement(
              'i',
              {
                class: {
                  'owl-rank-star': true,
                  'text-grey-light': true
                }
              }
            ))
          }
        }

        return createElement(
          'div',
          {
            class: {
              'rating-stars': true,
              'flex': true,
              'items-center': true
            }
          },
          [
            starsTemplate
          ]
        )
      }
    })
  }
}

// This exports the plugin object.
export default Plugin
